var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[(this.body)?_c('div',[_c(_vm.header.template,{tag:"component",attrs:{"text":_vm.body}})],1):_c('div',[_c('h1',[_vm._v("Still a WIP")])])])}
var staticRenderFns = []

export { render, staticRenderFns }